// extracted by mini-css-extract-plugin
export var button = "Content-module--button--ff6bc";
export var container = "Content-module--container--aaa92";
export var fadeInAnimation = "Content-module--fadeInAnimation--85e79";
export var oneIcon = "Content-module--oneIcon--43482";
export var smallerTitle = "Content-module--smallerTitle--2926f";
export var subtitle = "Content-module--subtitle--0b614";
export var threeIcons = "Content-module--threeIcons--e0b55";
export var title = "Content-module--title--27d83";
export var twoIcons = "Content-module--twoIcons--970f4";
export var withoutDot = "Content-module--withoutDot--e54e4";